export const namesFromTypes = (valueNameObject) => {
  let returnObject = {};
  Object.values(valueNameObject).forEach((objectValue) => {
    returnObject[objectValue.value] = objectValue.name;
  });

  return returnObject;
};
